import { render } from "./Planning4DPage.vue?vue&type=template&id=bd3becea&scoped=true&ts=true"
import script from "./Planning4DPage.vue?vue&type=script&lang=ts"
export * from "./Planning4DPage.vue?vue&type=script&lang=ts"

import "./Planning4DPage.vue?vue&type=style&index=0&id=bd3becea&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3becea"]])

export default __exports__